// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app-profile-attrib {\n  display: flex;\n  margin-bottom: 17px;\n}\n@media (max-width: 425px) {\n  .app-profile-attrib {\n    flex-direction: column;\n  }\n}\n.app-profile-attrib p {\n  margin: 0;\n}\n.app-profile-attrib-label {\n  width: 180px;\n  font-weight: 700;\n}\n.app-profile-attrib img {\n  max-width: 100%;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
